"use client"

import * as React from "react"
import { Check, ChevronsUpDown } from "lucide-react"
import { cn } from "src/lib/utils"
import { Button } from "src/Components/ui/button"
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "src/Components/ui/command"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "src/Components/ui/popover"
import { useController } from "react-hook-form"
import { useTranslation } from "react-i18next"

export function ComboboxMultiSelectForm({ name, control, ...props }) {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)

  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: [], // default as array
  })

  const idKey = props.idKey || "id"

  const toggleSelection = (itemId) => {
    const current = field.value || []
    const newValue = current.includes(itemId)
      ? current.filter((id) => id !== itemId)
      : [...current, itemId]
    field.onChange(newValue)
  }

  const selectedItems = props.data?.filter((item) =>
    field.value?.includes(item[idKey])
  )

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn("w-72 justify-between", error && "border-red-500")}
        >
          {selectedItems?.length > 0
            ? selectedItems.map((item) => item[props.lable]).join(", ")
            : props.placeholder}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0">
        <Command>
          <CommandInput placeholder={t("gloabl.search") + "..."} />
          <CommandList>
            <CommandEmpty>{t("errorMessage.noData")}</CommandEmpty>
            <CommandGroup>
              {props.data?.map((item) => (
                <CommandItem
                  key={item[idKey]}
                  onSelect={() => toggleSelection(item[idKey])}
                  className="cursor-pointer"
                >
                  <Check
                    className={cn(
                      "mr-2 h-4 w-4",
                      field.value?.includes(item[idKey])
                        ? "opacity-100"
                        : "opacity-0"
                    )}
                  />
                  {item[props.lable]}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
